import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderProgressDciOverview extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
    }

    getItemHtml(item, relatedMedia) {
        const url = `/connectors/${item.UrlName}`;
        const html = `
        <div class="col-4 -mh100 -mt2 -l-third -l-mt3 -m-half -z2">
            <a href="${url}" class="-bg-blue6 -br5 -df -full -p1 -h10">
                <div class="-full -h100">
                    <img src="${item.Logo[0].Url}" class="-ma" style="align-self:center;max-height:100%;" />
                </div>
            </a>
            <h5 class="-fs15 -pt1 -mb0">
                <a href="${url}" class="-c-link -h-c-link">${this.encodeHtml(item.Title)}</a>
            </h5>
        </div>
    `;

        return html;

    }
}
